module.exports = __webpack_public_path__ + "img/矩形 78@1x.78c31136.png";